import { UPDATE_PRIORITY } from "pixi.js";
export class AnimatedSpriteWrap extends PIXI.AnimatedSprite {
    constructor(pixiContext, textures) {
        const autoUpdate = false;
        super(textures, autoUpdate);
        this.pixiContext = pixiContext;
    }
    play() {
        super.play();
        // super가 constructor에서 호출할 때 대비해서 null체크
        if (this.pixiContext != null) {
            this.pixiContext.ticker.add(this.update, this, UPDATE_PRIORITY.HIGH);
        }
    }
    stop() {
        super.stop();
        // super가 constructor에서 호출할 때 대비해서 null체크
        if (this.pixiContext != null) {
            this.pixiContext.ticker.remove(this.update, this);
        }
    }
}
//# sourceMappingURL=animatedSprite.js.map